<template lang="pug">
v-container(fluid).pa-0
  portal(to="region.dialog" v-slot="{ close, attrs }")
    v-card.sdo-card
      v-list-item
        v-list-item-title: v-card-title: strong Регионы
        v-list-item-action
          v-btn(icon color="error" @click="close"): v-icon mdi-close
      v-window(v-model="window")
        v-window-item
          v-card-text
            v-list
              v-list-item(
                v-for="(region, idx) in regions"
                :key="region.id"
              )
                v-list-item-avatar
                  span {{ region.code }}
                v-list-item-title: strong {{ region.name }}
                v-list-item-action
                  v-btn(
                    :loading="loadingRegionId === region.id"
                    icon color="error" @click="detachRegion(idx, region.id)"
                  ): v-icon mdi-delete
          v-card-actions
            v-btn.ml-auto(
              v-if="!isMentor"
                color="primary" outlined @click="window = 1"
              ) Прикрепить новый регион
        v-window-item
          v-card-text
            region-picker.pt-2(v-model="payload" onlyRegion)
          v-card-actions
            v-btn.ml-auto(
              color="primary"
              :loading="loading"
              @click="attachRegion"
            ) Прикрепить
  v-row(v-if="regions").ma-0
    v-chip.ml-auto.pl-5.pr-0(
      v-if="regions.length"
      outlined color="secondary" @click="showAttachRegion"
    ) Регионы:
      v-chip(color="secondary").ml-4 {{ regions.length }}
    v-alert.mt-6(
      v-else-if="!isMentor"
      type="info"
      text
      prominent
    )
      .d-flex.align-center
        span Укажите регионы, в которых вы будете осуществлять наставничество
        v-spacer
        v-btn.ml-auto(color="info" @click="showAttachRegion") Прикрепить
  v-row.mt-0
    v-col
      v-card(
        :to="{ name: 'MentorResources' }"
        active-class="dark-active"
      ).sdo-card.fill-height
        v-card-text.px-5.pb-0
          h3.mb-3 Ресурсы
          p Практики и образовательные программы
        v-card-actions.pt-0
          v-btn.ml-auto(
            active-class="white"
            :color="['MentorResources'].includes($route.name) ? 'white' : 'black'"
            small outlined
            :to="{ name: 'PracticeTagList' }"
          )
            | Метки
            v-icon(small).ml-2 mdi-tag-multiple

    v-col
      v-card(
        :to="{ name: 'MentorsList' }"
        active-class="dark-active"
      ).sdo-card.fill-height
        v-card-text.px-5.pb-0
          template(v-if="isMentor")
            h3.mb-3() Наставляемые
            p ??????????????
          template(v-else)
            h3.mb-3() Наставники и наставляемые
            p Прикрепление педагогов региона к наставникам

        div(
          v-if="hasRequest"
          style="top: 0px; right: 0px; position: absolute"
        )
          tooltip-wrap(
            text="есть новые заявки"
          )
            v-btn.absolute(
              color="warning" fab small depressed text
              :to="{ name: 'MentorsList', query: { tab: 1, subTab: 0 } }"
            )
              v-icon mdi-account-alert
            //- span.text-caption.white--text есть новая заявка
    v-col
      v-card(
        :to="{ name: 'MentorQuestionnaire' }"
        active-class="dark-active"
      ).sdo-card.fill-height
        v-card-text.px-5.pb-0
          h3.mb-3 Анкеты
          p для проведения тестирования - интервьюирования
  .d-flex.pt-4(
    v-if="!isMentor"
  )
    v-alert(
      v-if="categories && !categories.length"
      type="warning"
      text
      prominent
    )
      .d-flex.align-center
        span Добавьте категории, в которых вы будете осуществлять наставничество
        v-spacer
        v-btn.ml-auto(color="info" @click="openCategories") Добавить
    v-btn.ml-auto(
      v-else
      color="secondary" outlined
      @click="openCategories"
    )
      | Категории
      v-icon(right) mdi-cog

  router-view

</template>
<script>
import RegionPicker from '@/components/InputFields/RegionPicker/index.vue';
import CategoriesModal from './components/CategoriesModal.vue';

export default {
  components: {
    RegionPicker,
  },
  data() {
    return {
      payload: {},
      regions: [],
      loading: false,
      loadingRegionId: null,
      hasRequest: false,
      window: 0,
      categories: null,
    };
  },
  computed: {
    isMentor() {
      return this.$user.isMentor;
    },
  },
  async created() {
    if (!this.isMentor) {
      const { data } = await this.$api.dir.organizationShow(this.$user.organization.id, { expand: 'distributed_regions' });
      this.regions = data.data.distributed_regions || [];
      if (this.regions.length === 0) this.window = 1;

      const res = await this.$api.mentoring.getCategories();
      this.categories = res.data.data;
      this.getRequest();
    }
  },
  methods: {
    openCategories() {
      this.$modals.show('generic-controller', {
        title: 'Категории',
        dialogProps: {
          width: 800,
        },
        component: CategoriesModal,
      });
    },
    async getRequest() {
      const { data } = await this.$api.mentoring.requestList(this.$user.organization.id, { 'search[is_active]': 0 });
      this.hasRequest = Boolean(data.data.length);
    },
    showAttachRegion() {
      this.$modals.show('dialog-portal', {
        dialogProps: {
          width: 1000,
        },
        inputValue: 'region',
      });
    },
    async attachRegion() {
      this.loading = true;
      const { data } = await this.$api.system.regions({ 'search[code]': this.payload.region.code });
      const payload = {
        region_ids: [data.data[0].id],
      };
      this.payload.region = null;
      await this.$api.mentoring.attachRegion(payload);
      this.regions.push(data.data[0]);
      this.window = 0;
      this.loading = false;
    },
    async detachRegion(idx, id) {
      this.loadingRegionId = id;
      const payload = {
        region_ids: [id],
      };
      await this.$api.mentoring.detachRegion(payload);
      this.regions.splice(idx, 1);
      this.loadingRegionId = null;
    },
  },
};
</script>
